// i18n — Sicherheit (Settings-Nav + MFA/TOTP).

export const securityMessages = {
  en: {
    settingsNav: {
      security:     'Security',
      securityDesc: 'Password, 2FA & passkeys',
    },
    login: {
      mfaTitle:      'Two-factor authentication',
      mfaHelp:       'Enter the 6-digit code from your authenticator app, or a recovery code.',
      otpLabel:      'Authentication code',
      rememberDevice:'Trust this device for 7 days',
      verifyBtn:     'Verify',
      mfaBack:       'Back to login',
      mfaInvalid:    'Invalid or expired code.',
    },
    mfa: {
      title:         'Two-factor authentication (2FA)',
      intro:         'Protect your account with a time-based one-time code (TOTP) from an authenticator app, in addition to your password.',
      statusActive:  'Active',
      statusInactive:'Inactive',

      enableBtn:     'Set up 2FA',
      // Setup wizard
      setupTitle:    'Set up two-factor authentication',
      setupScanIntro:'Scan this QR code with your authenticator app (e.g. Google Authenticator, 1Password, Authy).',
      setupSecretLabel: 'Or enter this key manually:',
      codeLabel:     'Enter the 6-digit code from your app',
      codePlaceholder: '123456',
      confirmEnableBtn: 'Activate',
      codeInvalid:   'That code is not valid. Please try again.',
      enabledSuccess:'Two-factor authentication is now active.',

      // Backup codes
      backupTitle:   'Save your recovery codes',
      backupIntro:   'Each code can be used once if you lose access to your authenticator app. Keep them somewhere safe.',
      backupWarn:    'These codes are shown only once.',
      copyBtn:       'Copy',
      copied:        'Copied to clipboard',
      downloadBtn:   'Download',
      doneBtn:       'Done',
      backupRemaining:'recovery codes left',
      regenerateBtn: 'Regenerate codes',
      regenTitle:    'Regenerate recovery codes',
      regenIntro:    'Your existing recovery codes will stop working. Confirm with your password.',
      regenConfirmBtn:'Generate new codes',

      // Disable
      disableBtn:    'Disable 2FA',
      disableTitle:  'Disable two-factor authentication',
      disableIntro:  'This removes 2FA, all recovery codes and trusted devices. Confirm with your password.',
      passwordLabel: 'Current password',
      disableConfirmBtn:'Disable',
      disabledSuccess:'Two-factor authentication disabled.',
      wrongPassword: 'Wrong password.',

      // Trusted devices
      trustedTitle:  'Trusted devices',
      trustedEmpty:  'No trusted devices. Devices you mark as trusted at login appear here.',
      trustedIntro:  'These devices skip the 2FA prompt until they expire.',
      lastUsed:      'Last used',
      expires:       'Expires',
      revoke:        'Revoke',
      revokeAll:     'Revoke all',
      revokeConfirm: 'Revoke this trusted device?',
      revokeAllConfirm: 'Revoke all trusted devices? They will need 2FA again at next login.',
      revokedSuccess:'Trusted device revoked.',

      loadFailed:    'Could not load 2FA status.',
      genericError:  'Something went wrong.',
    },
  },

  de: {
    settingsNav: {
      security:     'Sicherheit',
      securityDesc: 'Passwort, 2FA & Passkeys',
    },
    login: {
      mfaTitle:      'Zwei-Faktor-Authentifizierung',
      mfaHelp:       'Gib den 6-stelligen Code aus deiner Authenticator-App ein — oder einen Wiederherstellungs-Code.',
      otpLabel:      'Authentifizierungs-Code',
      rememberDevice:'Diesem Gerät 7 Tage vertrauen',
      verifyBtn:     'Bestätigen',
      mfaBack:       'Zurück zum Login',
      mfaInvalid:    'Ungültiger oder abgelaufener Code.',
    },
    mfa: {
      title:         'Zwei-Faktor-Authentifizierung (2FA)',
      intro:         'Schütze deinen Account zusätzlich zum Passwort mit einem zeitbasierten Einmal-Code (TOTP) aus einer Authenticator-App.',
      statusActive:  'Aktiv',
      statusInactive:'Inaktiv',

      enableBtn:     '2FA einrichten',
      // Einrichtungs-Assistent
      setupTitle:    'Zwei-Faktor-Authentifizierung einrichten',
      setupScanIntro:'Scanne diesen QR-Code mit deiner Authenticator-App (z. B. Google Authenticator, 1Password, Authy).',
      setupSecretLabel: 'Oder gib diesen Schlüssel manuell ein:',
      codeLabel:     'Gib den 6-stelligen Code aus deiner App ein',
      codePlaceholder: '123456',
      confirmEnableBtn: 'Aktivieren',
      codeInvalid:   'Dieser Code ist ungültig. Bitte erneut versuchen.',
      enabledSuccess:'Zwei-Faktor-Authentifizierung ist jetzt aktiv.',

      // Backup-Codes
      backupTitle:   'Sichere deine Wiederherstellungs-Codes',
      backupIntro:   'Jeder Code ist einmalig nutzbar, falls du den Zugriff auf deine Authenticator-App verlierst. Bewahre sie sicher auf.',
      backupWarn:    'Diese Codes werden nur einmalig angezeigt.',
      copyBtn:       'Kopieren',
      copied:        'In die Zwischenablage kopiert',
      downloadBtn:   'Herunterladen',
      doneBtn:       'Fertig',
      backupRemaining:'Wiederherstellungs-Codes übrig',
      regenerateBtn: 'Codes neu erzeugen',
      regenTitle:    'Wiederherstellungs-Codes neu erzeugen',
      regenIntro:    'Deine bestehenden Wiederherstellungs-Codes werden ungültig. Bestätige mit deinem Passwort.',
      regenConfirmBtn:'Neue Codes erzeugen',

      // Deaktivieren
      disableBtn:    '2FA deaktivieren',
      disableTitle:  'Zwei-Faktor-Authentifizierung deaktivieren',
      disableIntro:  'Das entfernt 2FA, alle Wiederherstellungs-Codes und vertrauenswürdigen Geräte. Bestätige mit deinem Passwort.',
      passwordLabel: 'Aktuelles Passwort',
      disableConfirmBtn:'Deaktivieren',
      disabledSuccess:'Zwei-Faktor-Authentifizierung deaktiviert.',
      wrongPassword: 'Falsches Passwort.',

      // Vertrauenswürdige Geräte
      trustedTitle:  'Vertrauenswürdige Geräte',
      trustedEmpty:  'Keine vertrauenswürdigen Geräte. Geräte, die du beim Login als vertrauenswürdig markierst, erscheinen hier.',
      trustedIntro:  'Diese Geräte überspringen die 2FA-Abfrage, bis sie ablaufen.',
      lastUsed:      'Zuletzt genutzt',
      expires:       'Läuft ab',
      revoke:        'Entfernen',
      revokeAll:     'Alle entfernen',
      revokeConfirm: 'Dieses vertrauenswürdige Gerät entfernen?',
      revokeAllConfirm: 'Alle vertrauenswürdigen Geräte entfernen? Beim nächsten Login wird wieder 2FA verlangt.',
      revokedSuccess:'Vertrauenswürdiges Gerät entfernt.',

      loadFailed:    '2FA-Status konnte nicht geladen werden.',
      genericError:  'Etwas ist schiefgelaufen.',
    },
  },
}
